<template>
  <section class="widget-list" v-if="chartData && chartData.length > 0">
    <section class="widget-list-item" v-for="item in chartData" :key="item.id">
      <h3>
        <span v-if="item.icon">{{ item.icon }}</span
        ><span
          v-else-if="item.marker"
          class="widget-list-item__bg-label"
          :style="{ backgroundColor: item.marker }"
        ></span
        >{{ item.label }}
      </h3>
      <ul class="widget-list-item__content">
        <li v-for="dimension in dimensions" :key="dimension.id">
          <span>{{ dimension.label }}</span>
          <span v-if="dimension.value">{{ valueComp(dimension, item) }}</span>
        </li>
      </ul>
    </section>
    <p v-if="footer">{{ footer }}</p>
  </section>
  <component v-else :is="fallback.tag || 'p'" v-bind="fallback.props">{{ fallback.label }}</component>
</template>

<script>
export default {
  props: {
    data: Object,
    source: Object,
  },
  computed: {
    dimensions() {
      if (!this.source || !this.data) return
      return typeof this.source.dimensions === 'function'
        ? this.source.dimensions({ data: this.data, source: this.source, colors: this.colors })
        : this.source.dimensions
    },
    footer() {
      if (!this.source.footer) return
      return typeof this.source.footer === 'function'
        ? this.source.footer({ data: this.data, source: this.source })
        : this.source.footer
    },
    chartData() {
      if (!this.source || !this.data) return
      return typeof this.source.data === 'function'
        ? this.source.data({ data: this.data, source: this.source, colors: this.colors })
        : this.source.data
    },
    colors() {
      if (!this.source || !this.data) return
      return typeof this.source.colors === 'function'
        ? this.source.colors({ data: this.data, source: this.source })
        : this.source.colors
    },
    fallback() {
      if (!this.source.fallback) return { label: this.$t('statisticsEmptyState') }
      return typeof this.source.fallback === 'function'
        ? this.source.fallback({ data: this.data, source: this.source })
        : this.source.fallback
    },
  },
  methods: {
    valueComp(dimension, item) {
      return typeof dimension.value === 'function'
        ? dimension.value({ source: this.source, data: this.data, item })
        : dimension.value
    },
  },
  components: {},
}
</script>

<style lang="scss">
.widget-list {
  width: 100%;
  &-item {
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    padding: 1rem 0;
    h3 {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-size: 1rem;
    }
    &__bg-label {
      width: 16px;
      height: 16px;
      position: relative;
      display: inline-block;
      border-radius: 100%;
    }
    &__content {
      list-style: none;
      padding: 0;
      display: flex;
      justify-content: space-between;
      width: 100%;

      li {
        display: flex;
        flex-direction: column;
      }
    }
  }
}
</style>
